module.exports = __webpack_public_path__ + "img/22_53.2d64fdc3.png";